import React from "react";

const IconDot = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="5"
      viewBox="0 0 6 5"
      fill="none"
    >
      <ellipse cx="2.64716" cy="2.5" rx="2.50262" ry="2.5" fill="#F1F2F4" />
    </svg>
  );
};

export default IconDot;
